import React, { useRef, useState } from 'react';

type Props = {
  inFooter?: boolean;
  isHoveredFromFooter?: boolean;
  isHidden?: boolean;
};

export const RemoveThreadIcon: React.FC<Props> = ({
  inFooter,
  isHoveredFromFooter,
  isHidden,
}: Props): JSX.Element => {
  const [hover, setIsHover] = useState(false);

  const svgRef = useRef<HTMLDivElement>(null);

  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const fillCol = hover || isHoveredFromFooter ? '#2f86c7' : '#4eb4ff';

  const getCoordinatesForTooltip = () => {
    let xCoord = '';
    let yCoord = '';
    if (svgRef?.current?.getClientRects()?.length) {
      const { x, y } = svgRef.current.getClientRects()[0];
      xCoord = `${x + 20}px`;
      yCoord = `${y + 8}px`;
    }
    return { xCoord, yCoord };
  };

  const { xCoord, yCoord } = getCoordinatesForTooltip();

  const tooltip = (
    <span
      className={hover ? 'open remove-thread-tooltip' : 'remove-thread-tooltip'}
      style={
        yCoord && xCoord && hover && !inFooter
          ? { position: 'fixed', top: yCoord, left: xCoord }
          : {}
      }
    >
      Remove from list
    </span>
  );

  return (
    <div className={`${isHidden ? 'hidden' : ''} remove-thread`} ref={svgRef}>
      {isHoveredFromFooter || isHidden ? null : tooltip}
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        className="remove-thread-svg"
      >
        <path
          d="M6.66659 3.33333H9.33325C9.33325 2.59695 8.7363 2 7.99992 2C7.26354 2 6.66659 2.59695 6.66659 3.33333ZM5.66659 3.33333C5.66659 2.04467 6.71125 1 7.99992 1C9.28858 1 10.3333 2.04467 10.3333 3.33333H14.1666C14.4427 3.33333 14.6666 3.55719 14.6666 3.83333C14.6666 4.10948 14.4427 4.33333 14.1666 4.33333H13.2872L12.5058 12.4075C12.3818 13.6889 11.3049 14.6667 10.0175 14.6667H5.98238C4.69494 14.6667 3.61802 13.6889 3.49401 12.4075L2.71264 4.33333H1.83325C1.55711 4.33333 1.33325 4.10948 1.33325 3.83333C1.33325 3.55719 1.55711 3.33333 1.83325 3.33333H5.66659ZM6.99992 6.5C6.99992 6.22386 6.77606 6 6.49992 6C6.22378 6 5.99992 6.22386 5.99992 6.5V11.5C5.99992 11.7761 6.22378 12 6.49992 12C6.77606 12 6.99992 11.7761 6.99992 11.5V6.5ZM9.49992 6C9.77606 6 9.99992 6.22386 9.99992 6.5V11.5C9.99992 11.7761 9.77606 12 9.49992 12C9.22378 12 8.99992 11.7761 8.99992 11.5V6.5C8.99992 6.22386 9.22378 6 9.49992 6ZM4.48936 12.3112C4.56376 13.08 5.20992 13.6667 5.98238 13.6667H10.0175C10.7899 13.6667 11.4361 13.08 11.5105 12.3112L12.2825 4.33333H3.71731L4.48936 12.3112Z"
          fill={fillCol}
        />
      </svg>
    </div>
  );
};
